import { RouteConfig } from 'vue-router';
import { invitedSitterTokenGuard } from '@/router/guards/backupCareGuards';

const backupCareInviteRoutes: RouteConfig[] = [
  {
    path: '/backup-care/:interview_request_id/invite/:invited_sitter_id/:invited_sitter_token',
    name: 'backup-care-invited-sitter-token',
    beforeEnter: invitedSitterTokenGuard,
  },
];

export default backupCareInviteRoutes;
